<template>
  <v-navigation-drawer
    id="viewerSideDrawer"
    color="primary"
    style="z-index: 5; opacity: 0.9"
    class="remove-scroll"
    absolute
    permanent
    touchless
    dark
    right
    width="325px"
  >
    <structure-tree-panel v-show="sideDrawer === 'productStructure'"></structure-tree-panel>
    <model-views-panel v-show="sideDrawer === 'modelViews'"></model-views-panel>
    <properties-panel v-show="sideDrawer === 'properties'"></properties-panel>
    <pmi-filters-panel v-show="sideDrawer === 'pmiFilters'"></pmi-filters-panel>
    <markup-views-panel v-show="sideDrawer === 'markupViews'"></markup-views-panel>
    <settings-panel v-show="sideDrawer === 'settings'"></settings-panel>
  </v-navigation-drawer>
</template>

<script>
import StructureTreePanel from "@/components/Panels/StructureTreePanel";
import ModelViewsPanel from "@/components/Panels/ModelViewsPanel";
import PropertiesPanel from "@/components/Panels/PropertiesPanel";
import PmiFiltersPanel from "@/components/Panels/PmiFiltersPanel";
import MarkupViewsPanel from "@/components/Panels/MarkupViewsPanel";
import SettingsPanel from "@/components/Panels/SettingsPanel";

import { mapState } from "vuex";

export default {
  components: {
    "structure-tree-panel": StructureTreePanel,
    "model-views-panel": ModelViewsPanel,
    "properties-panel": PropertiesPanel,
    "pmi-filters-panel": PmiFiltersPanel,
    "markup-views-panel": MarkupViewsPanel,
    "settings-panel": SettingsPanel
  },
  data: () => ({}),
  computed: {
    ...mapState(["touchScreenDevice", "sideDrawer"])
  }
};
</script>

<style>
.remove-scroll.v-navigation-drawer > .v-navigation-drawer__content {
  overflow: hidden;
}
</style>
